import { RefObject, useEffect } from 'react';

const useOnClickOutside = (
  ref: RefObject<HTMLElement | null>,
  onClickOutside: () => void,
) => {
  useEffect(() => {
    const onMouseDown = (event: MouseEvent) => {
      if (!ref.current || event.composedPath().includes(ref.current)) return;

      onClickOutside();
    };

    document.addEventListener('mousedown', onMouseDown);

    return () => document.removeEventListener('mousedown', onMouseDown);
  }, [onClickOutside, ref]);
};

export default useOnClickOutside;
